<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <ActiveMovementForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActiveMovementForm from '@/components/reports/activemovement/ActiveMovementForm'

export default {
  name: 'ActiveMovementAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    ActiveMovementForm
  }
}
</script>